module.exports = __webpack_public_path__ + "static/img/pro6.bf07ca5b.jpg";